// TODO: Move sharing to src/common/component/
(function () {
  'use strict'

  require('./scss/sharing.scss')

  const MODULE_NAME = 'thismoment.card.component.sharing'
  const templateUrl = require('./tpl/sharing.html')

  require('angular')
    .module(MODULE_NAME, [
      require('angular-animate'),
      require('../../analytics'),
      require('../../content')
    ])
    // TODO: Make bindings agree across all components... they should either be 'ccmt{Content,Playlist}Id' or '{content,playlist}Id', but not both
    .component('thismomentSharing', {
      bindings: {
        analyticsProps: '<',
        ccmtContentId: '<',
        customStyles: '<',
        item: '<',
        playlistId: '<'
      },
      templateUrl: templateUrl,
      controller: sharingController
    })

  sharingController.$inject = ['$injector', '$httpParamSerializer', '$location', 'analyticsSDK', 'SdkConfig']
  function sharingController ($injector, $httpParamSerializer, $location, analyticsSDK, SdkConfig) {
    const vm = this

    vm.$onInit = sharingInit

    function sharingInit () {
      let pageId
      if ($injector.has('GlowConfig')) {
        const GlowConfig = $injector.get('GlowConfig')
        const page = GlowConfig.getCurrentPage()
        pageId = page.get('id')
      } else {
        pageId = null
      }

      const queryParams = {
        playlist_id: vm.playlistId,
        content_id: vm.item.id,
        glow_page_id: pageId,
        url: encodeURIComponent('https://' + $location.host() + $location.path() + '?playlistId=' + vm.playlistId + '&contentId=' + vm.item.id)
      }
      const baseShareUrl = SdkConfig.get('content_cloud_url') + '/thismoment-share?' + $httpParamSerializer(queryParams)

      vm.trackEvent = analyticsSDK.setupEventTracking(vm.analyticsProps)

      vm.url = {
        facebook: baseShareUrl + '&target=facebook',
        x: baseShareUrl + '&target=x',
        email: baseShareUrl + '&target=email'
      }

      vm.isX = (vm.item.source.source_name === 'x')
      if (vm.isX) {
        vm.sourceId = vm.item.source.origin_id
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/card/component/sharing.js